module.exports = __webpack_public_path__ + "img/alipay_hk.abee9924.png";